import ShowcaseCollection from './ShowcaseCollection';

export default ShowcaseCollection;
